export default __webpack_public_path__ + "static/media/orders.02f5f09c.png";